import { getDataAutoTestAttributes, type DataAttributes } from 'shared/lib/data-auto-test';
import type { InfoTooltip } from 'shared/ui/CommonCard';
import { CommonCard } from 'shared/ui/CommonCard';

interface OverlappingCardProps {
  label: string;
  color?: string;
  infoTooltips?: InfoTooltip[];
  size?: 'small' | 'medium' | 'large';
  onAction?: ((e: React.MouseEvent<HTMLElement>) => void) | (() => void);
  actionIconName?: string;
  isActionDisabled?: boolean;
  className?: string;
  cardData?: {
    current: number;
    previous?: number;
    percentage?: number;
    difference: number;
  } | null;
  blockAttributes?: DataAttributes;
}

export function OverlappingCard({
  label,
  color,
  infoTooltips,
  onAction,
  cardData,
  className,
  size,
  actionIconName,
  isActionDisabled,
  blockAttributes,
}: OverlappingCardProps) {
  return (
    <CommonCard
      attributes={blockAttributes}
      size={size}
      className={className}
      color={color}
      {...getDataAutoTestAttributes(['overlapping-wrapper'])}
    >
      <CommonCard.TopBlock>
        <CommonCard.Label
          label={label}
          infoTooltips={infoTooltips}
        />
        {actionIconName && (
          <CommonCard.ActionBtn
            onAction={onAction}
            iconName={actionIconName}
            isDisabled={isActionDisabled}
            attributes={getDataAutoTestAttributes(['overlapping-wrapper-download-unique-zips']).attributes}
          />
        )}
      </CommonCard.TopBlock>
      {cardData && (
        <CommonCard.CurrentPreviousNumber
          current={cardData.current}
          previous={cardData.previous}
          difference={cardData.difference}
          percentage={cardData.percentage}
        />
      )}
    </CommonCard>
  );
}
